const Announced = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path d="M14.29 8 2.798 14.268V1.732L14.29 8ZM4.798 5.101V10.9L10.113 8 4.798 5.101Z" />
    </svg>
);

export default Announced;
